import { Dialog } from "@mui/material";
import { useState } from "react";
import { Icon } from "@iconify/react";
import {
  Box,
  HStack,
  VStack,
  ButtonPrimary,
  ButtonPrimary1,
} from "../../../../components/utils";
import { Input, Label } from "../../../../components/shared/InputField";

interface DirectRejectDialogProps {
  open: boolean;
  employeeName?: string;
  onClose: () => void;
  onSubmit: (reason?: string) => void;
  loading?: boolean;
}

export default function DirectRejectDialog({
  open,
  employeeName,
  onClose,
  onSubmit,
  loading,
}: DirectRejectDialogProps) {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <VStack className="">
        <div className="p-4 mt-4 text-lg font-medium border-b selection:ml-3 stone-700">
          <h6 className="flex justify-between">
            Reject Exercise Request
            <span onClick={handleClose} className="cursor-pointer">
              X
            </span>
          </h6>
        </div>
        <div className="p-4">
          <p className="text-sm text-gray-700 mb-3">
            Are you sure you want to reject the exercise request for{" "}
            <b>{employeeName || "this employee"}</b>?
          </p>
          <VStack className="p-2 text-black-501 bg-yellow-100 rounded">
            <HStack className="pt-0 justify-start">
              <HStack className="gap-1 pl-1 items-center">
                <Icon
                  icon="material-symbols:info-outline-rounded"
                  height={18}
                  width={18}
                  className="w-full text-xs font-medium text-black-501 rounded"
                />
                <p className="text-sm">Note</p>
              </HStack>
            </HStack>
            <Box className="pl-5 pt-2 pb-1">
              <ul className="list-disc">
                <li className="text-xs pt-0.5">
                  The offer will be moved to Rejected state immediately
                </li>
                <li className="text-xs pt-0.5">
                  The employee will no longer be able to exercise their options
                </li>
                <li className="text-xs pt-0.5">
                  This action cannot be undone from the share issuance step
                </li>
              </ul>
            </Box>
          </VStack>
        </div>
        <div className="p-4">
          <Label className="mr-10 text-sm font-normal whitespace-nowrap">
            Reason for rejection (optional)
          </Label>
          <Input
            placeholder="e.g. Payment not received within the deadline"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
        <HStack className="justify-between gap-2 p-4">
          <ButtonPrimary1 onClick={handleClose} disabled={loading}>
            Cancel
          </ButtonPrimary1>
          <ButtonPrimary
            onClick={() => onSubmit(reason)}
            loading={loading}
            className="bg-red-500 hover:bg-red-600"
          >
            Reject
          </ButtonPrimary>
        </HStack>
      </VStack>
    </Dialog>
  );
}
